/** Source value stored in `trades.created_via` when saving from the dashboard quick-add modal. */
export const QUICK_ADD_TRADE_MODAL_SOURCE = 'quick-add-trade-modal' as const
